import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AlertaService } from '@shared/services/alerta.service';
import { ComisionRevisionService } from '@shared/services/api/comision-revision.service';

@Component({
  selector: 'app-confirmar-reserva',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './confirmar-reserva.component.html',
  styles: ``,
})
export class ConfirmarReservaComponent {
  private router = inject(Router);
  private comisionService = inject(ComisionRevisionService);
  private alertaService = inject(AlertaService);
  id = input.required<number>();

  aceptarHabilitacion() {
    this.alertaService
      .confirmacion('¿Está seguro de aceptar la habilitación al proceso de contratación?')
      .subscribe((confirmado) => {
        if (confirmado) {
          this.comisionService.aceptarHabilitacion(this.id()).subscribe({
            next: () => {
              this.router.navigate(['/']);
            },
          });
        }
      });
  }
}
